import { useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Textarea,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useCancelShiftMutation } from "../hooks/useCancelShiftMutation";

const MOTIVO_MIN_LENGTH = 3;

// Confirmação antes de cancelar (soft delete): o plantão some dos totais/recebíveis, mas
// o registro continua guardado no banco para histórico — por ser uma ação que tira valor
// dos totais financeiros do usuário, pede confirmação explícita em vez de agir direto no
// clique do menu. O motivo é obrigatório (backend rejeita cancelamento sem motivo) para
// que o histórico de cancelamentos seja útil de verdade.
export default function CancelShiftDialog({ isOpen, onClose, shift }) {
  const toast = useToast();
  const cancelRef = useRef(null);
  const mutation = useCancelShiftMutation();
  const [motivo, setMotivo] = useState("");
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const motivoInvalido = motivo.trim().length < MOTIVO_MIN_LENGTH;

  const close = () => {
    setMotivo("");
    setTentouEnviar(false);
    onClose();
  };

  const confirm = () => {
    if (motivoInvalido) {
      setTentouEnviar(true);
      return;
    }
    mutation.mutate(
      { id: shift.id, motivo: motivo.trim() },
      {
        onSuccess: () => {
          toast({ title: "Plantão cancelado", status: "success", duration: 4000 });
          close();
        },
        onError: (error) =>
          toast({
            title: "Não foi possível cancelar o plantão",
            description: error.response?.data?.mensagem,
            status: "error",
            duration: 5000,
            isClosable: true,
          }),
      }
    );
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={close} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Cancelar plantão
          </AlertDialogHeader>
          <AlertDialogBody>
            {shift ? (
              <Text mb={4}>
                O plantão de {shift.vinculo_nome} em {shift.data} sairá dos seus totais e recebíveis. O registro fica
                guardado para histórico, mas essa ação não pode ser desfeita pela tela.
              </Text>
            ) : null}
            <FormControl isInvalid={tentouEnviar && motivoInvalido}>
              <FormLabel>Motivo do cancelamento</FormLabel>
              <Textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                placeholder="Ex.: hospital cancelou a escala, imprevisto pessoal..."
                rows={3}
              />
              <FormErrorMessage>Informe o motivo (mínimo {MOTIVO_MIN_LENGTH} caracteres).</FormErrorMessage>
            </FormControl>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} variant="ghost" onClick={close} isDisabled={mutation.isPending}>
              Voltar
            </Button>
            <Button
              bg="danger.500"
              color="white"
              _hover={{ bg: "danger.600" }}
              _active={{ bg: "danger.700" }}
              onClick={confirm}
              isLoading={mutation.isPending}
            >
              Cancelar plantão
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
